"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Widget-Gruppe.
 *
 * @class
 * @extends gc.gis.widget.GCItem
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {Array<Object<string,*>>} options.items
 */
gc.gis.widget.GCWidgetGroup = function(options)
{
    this.items = options.items || [];

    gc.gis.widget.GCItem.call(this, options);
};
gc.gis.widget.GCWidgetGroup.prototype = Object.create(gc.gis.widget.GCItem.prototype);


/**
 * Liefert die Items der Gruppe.
 *
 * @return {gc.gis.widget.GCItem[]}
 */
gc.gis.widget.GCWidgetGroup.prototype.getItems = function()
{
    return this.items;
};

/**
 * Fügt ein Item der Gruppe hinzu.
 *
 * @param {gc.gis.widget.GCItem} item
 * @return {gc.gis.widget.GCWidgetGroup}
 */
gc.gis.widget.GCWidgetGroup.prototype.addItem = function(item)
{
    this.addItems(item);
};

/**
 * Fügt eine Liste von Items der Gruppe hinzu.
 *
 * @param {gc.gis.widget.GCItem[]} items
 * @return {gc.gis.widget.GCWidgetGroup}
 */
gc.gis.widget.GCWidgetGroup.prototype.addItems = function(items)
{
    if(typeof items === 'Array')
    {
        for(var i=0; i<items.length; i++)
        {
            this.items.push(items[i]);
        }
    }
    else
    {
        this.items.push(items);
    }
    this._render();
    return this;
};

/**
 * Liefert die Anzahl der Elemente der Gruppe.
 *
 * @return {int}
 */
gc.gis.widget.GCWidgetGroup.prototype.numItems = function()
{
	return this.items.length;
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCWidgetGroup.prototype._render = function()
{
    var self = this;
    var items = this.getItems();

    // Label
    this.element_control = undefined;
    if( this.label || this.icon || this.tooltip )
    {
        // Labeltext
        var element_label_text = jQuery('<span>', {
            'class': 'gc-widget-label-text',
            text: (self.label ? self.label : '')
        });

        // Tooltip
        var element_tooltip_text = jQuery('<span>', {
            'class': 'gc-widget-tooltip-text',
            text: (self.tooltip ? self.tooltip : '')
        });

        // Labelelement
        this.element_control = jQuery('<button>', {
            title: self.tooltip ? self.tooltip : self.label,
            'class': 'gc-button gc-widget-label'
            + (self.tooltip ? ' gc-widget-tooltip' : '')
            + (self.badge ? ' gc-widget-badge' : '')
            + (self.className ? ' '+ self.className : ''),
            click: function( evt ) {
                evt.preventDefault();
                try
                {
                    // open menu
                    if (jQuery(self.element_ul).is(':visible')) {
                        self.element_ul.hide('fade');
                        return;
                    }

                    self.element_ul.show('fade');

                    // close function
                    var func = function (evt2) {
                        self.element_ul.hide('fade');
                    };
                    // close anywhere
                    $('html').one('click', func);
                    // close at item selection
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].length > 0) {
                            for (var j = 0; j < items[i][j].length; j++) {
                                items[i][j].getElement().one('click', func);
                            }
                        }
                        else {
                            items[i].getElement().one('click', func);
                        }
                    }
                    // don't close immediatly
                    self.element.one('click', function (evt2) {
                        evt.stopPropagation();
                    });

                    // execute additional actions
                    if (self.action) {
                        self.action.execute(self);
                    }
                    if (self.click) {
                        self.click.call(this, event);
                    }
                }
                catch( err )
                {
                    gc.gis.iface.log.error( self, err );
                }
                jQuery(this).blur();
            }
        });

        if( self.icon ) {
            self.element_control.append( jQuery('<span>', {
                'class': 'gc-icon '+ self.icon
            }) );
        }
        if( self.label ) {
            self.element_control.append( element_label_text );
        }
        if( self.tooltip ) {
            self.element_control.append( element_tooltip_text );
        }
        if( self.badge ) {
            self.element_control.append( self.badge.getElement() );
        }
    }

    // Item-Liste
    this.element_ul = jQuery('<div>', {
        'class': 'gc-widget-items'
    });
    if( this.label )
    {
        this.element_ul.hide();
    }

    var ul = jQuery('<ul>', {
        class: 'form-inline'    // for left-aligned and inline-block controls
    });
    var li;
    for( var i=0; i<items.length; i++ )
    {
        // getrennte Menügruppen
        if( items[i].length > 0 )
        {
            var list = items[i];

            ul = jQuery('<ul>');
            for( var j=0; j<list.length; j++ )
            {
                li = jQuery('<li>');
                li.append( list[j].getElement() );
                ul.append( li );
            }
        }
        // keine Menügruppen
        else
        {
            li = jQuery('<li>');
            li.append( items[i].getElement() );
            ul.append( li );
        }
        this.element_ul.append( ul );
    }

    // Container
    if( !this.element )
    {
        this.element = jQuery('<div>', {
            'class': 'gc-widget gc-widget-item gc-widget-group'
            + (self.containerClassName ? ' '+ self.containerClassName : '')
        });
    }
    else
    {
        this.element.children().remove();
    }

    if( this.element_control ) {
        this.element.append( this.element_control );
    }
    var element_ul_wrapper = jQuery('<div>', {
        'class': 'gc-widget-items-wrapper',
        html: self.element_ul
    });
    this.element.append( element_ul_wrapper );

    return this.element;
};
